module.exports = __webpack_public_path__ + "static/spread-02-2dae84e2685b7ad1fe6f1cfe59961111.jpg";